export const truncateFileName = (fileName, maxLength = 20) => {
	if (!fileName) return ""; // Handle undefined or null fileName

	if (fileName.length <= maxLength) return fileName;

	const extIndex = fileName.lastIndexOf(".");
	if (extIndex === -1) return fileName.slice(0, maxLength - 3) + "..."; // No extension case

	const extension = fileName.slice(extIndex);
	return `${fileName.slice(0, maxLength - extension.length - 3)}...${extension}`;
};

import { Audio } from "expo-av";
import * as Notifications from "expo-notifications";

let soundInstance = null;

export const playSound = async (soundFile) => {
	try {
		await Audio.setAudioModeAsync({
			playsInSilentModeIOS: true,
			allowsRecordingIOS: false,
			staysActiveInBackground: true,
			shouldDuckAndroid: false,
			playThroughEarpieceAndroid: false,
		});

		const { sound } = await Audio.Sound.createAsync(soundFile, { shouldPlay: true });
		await sound.playAsync();

		// Optional: Unload the sound after playback
		sound.setOnPlaybackStatusUpdate(async (status) => {
			if (status.didJustFinish) {
				await sound.unloadAsync();
			}
		});
	} catch (error) {
		console.log("Error playing sound:", error);
	}
};

export const playSoundUntilTasksComplete = async (soundFile) => {
	try {
		// Stop any existing sound first
		await stopSound();

		// Create a new sound instance
		soundInstance = new Audio.Sound();

		// Load the sound file
		await soundInstance.loadAsync(soundFile);

		// Set it to loop
		await soundInstance.setIsLoopingAsync(true);

		// Play the sound
		await soundInstance.playAsync();
	} catch (error) {
		console.error("Error playing sound:", error);
	}
};

// Function to stop sound
export const stopSound = async () => {
	try {
		// Check if sound instance exists
		if (soundInstance) {
			const status = await soundInstance.getStatusAsync();
			if (status.isLoaded) {
				await soundInstance?.stopAsync();
				await soundInstance?.unloadAsync();
			}
			soundInstance = null;
		}
	} catch (error) {
		console.error("Error stopping sound:", error);
	}
};

export const sendArrivalNotification = async () => {
	await Notifications.scheduleNotificationAsync({
		content: {
			title: "Your driver has arrived!",
			body: "Please come outside to meet your ride.",
			sound: "default", // Play default system sound
		},
		trigger: null,
	});
};

// write notification to let driver know there is new order
export const sendRideNotification = async () => {
	await Notifications.scheduleNotificationAsync({
		content: {
			title: "New task available!",
			body: `Safe ride`,
			sound: "default",
		},
		trigger: null,
	});
};

// Helper function to generate 4-digit OTP
export const generateOTP = () => {
	return Math.floor(1000 + Math.random() * 9000).toString();
};
